<template>
  <Record :title="featureFlag.key">
    <Set :label="$t('active')">
      <Field
        :isSwitch="true"
        type="checkbox"
        :value="featureFlag.isOn"
        @update:value="setIsOn" />
    </Set>
  </Record>
</template>

<script>
import Record from '@components/Record'
import Set from '@components/Set'
import { actions } from '@utils'

export default {
  components: {
    Record,
    Set,
  },
  props: {
    featureFlag: Object,
  },
  data() {
    return {
      isToggling: false,
    }
  },
  methods: {
    setIsOn(isOn) {
      return this.$wrap(
        () => this.PATCH_FEATURE_FLAG({
          id: this.featureFlag.id,
          isOn,
        }),
        'isToggling',
      )
    },
    ...actions('PATCH_FEATURE_FLAG'),
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "active": "Active"
  }
}
</i18n>
